const QuestionIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="7" stroke="#9ca3af" strokeWidth="1.2" />
    <path
      d="M6.5 6.5C6.5 5.67 7.17 5 8 5C8.83 5 9.5 5.67 9.5 6.5C9.5 7.17 9.05 7.73 8.43 7.93C8.18 8.01 8 8.23 8 8.5V9"
      stroke="#9ca3af"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
    <circle cx="8" cy="11" r="0.6" fill="#9ca3af" />
  </svg>
);

export default QuestionIcon;
